<template>
  <div>
    <div>
      <b-card-group>
        <b-card no-body>
          <b-collapse visible id="filterCollapse">
            <div class="card-body">
              <div>
                <b-form>
                  <b-row>
                    <b-col cols="1">
                      <b-button v-on:click="resetFilter" size="sm" variant="secondary" class="ml-2">
                        <font-awesome-icon icon="times" />
                        {{ $t('Сброс') }}
                      </b-button>
                    </b-col>
                    <filter-input
                      label="ID "
                      v-on:onBlur="search"
                      :cols="1"
                      v-model="form.externalId"
                    ></filter-input>
                    <filter-select
                      :label="$t('Статус')"
                      v-model="form.status"
                      :cols="2"
                      v-on:onChange="search"
                      :options="statuses"
                    ></filter-select>
                    <filter-select
                      :label="$t('Степень родства')"
                      v-model="form.kinship"
                      :cols="2"
                      v-on:onChange="search"
                      :options="kinshipTypes"
                    ></filter-select>
                    <filter-select
                      :cols="1"
                      :label="$t('Код РР')"
                      :disabled="$auth.user().isLr"
                      v-on:onChange="search"
                      v-model="form.lrOrganizationId"
                      :options="lrOrganizations"
                    ></filter-select>
                    <filter-select
                      :cols="1"
                      :label="$t('Код ТЦ')"
                      v-on:onChange="search"
                      v-model="form.tcOrganizationId"
                      :options="tcOrganizations"
                    ></filter-select>
                    <filter-select
                      :cols="2"
                      :label="$t('Координатор')"
                      v-on:onChange="search"
                      v-model="form.operatorId"
                      :options="operators"
                    ></filter-select>
                  </b-row>
                </b-form>
              </div>
            </div>
          </b-collapse>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import BaseFilter from '@/models/base.filter';

export default {
  extends: BaseFilter,
  name: 'filter-form',
  props: [
    'gender',
    'kinship',
    'status',
    'operatorId',
    'externalId',
    'lrOrganizationId',
    'tcOrganizationId',
  ],
  data() {
    return {
      form: {
        gender: this.gender || null,
        kinship: this.kinship || null,
        status: this.status || null,
        operatorId: this.operatorId || null,
        externalId: this.externalId || '',
        lrOrganizationId: this.lrOrganizationId || null,
        tcOrganizationId: this.tcOrganizationId || null,
      },
      statuses: [],
      kinshipTypes: [],
      operators: [],
      genders: [],
      lrOrganizations: [],
      tcOrganizations: [],
    };
  },
  watch: {
    coincidence: function() {
      this.form.coincidence = this.coincidence;
    },
    status: function() {
      this.form.status = this.status;
    },
    operatorId: function() {
      this.form.operatorId = this.operatorId;
    },
    externalId: function() {
      this.form.externalId = this.externalId;
    },
  },
  methods: {
    getDictionaries() {
      axios
        .get('/Dictionary/GetDonorStatuses?type=Relative')
        .then((response) => {
          this.statuses = response.data;
        });

      const orgId = this.$auth.user().isLr
        ? this.$auth.user().lrId ||
          this.$auth.user().impersonateOrganizationId ||
          this.$auth.user().organizationId
        : null;

      axios
        .get('/Dictionary/GetOperators?group=3&organizationId=' + orgId)
        .then((response) => {
          this.operators = response.data;
        });

      axios
        .get('/Dictionary/GetLrOrganizationCodes?isForRelatedDonors=true')
        .then((response) => {
          this.lrOrganizations = response.data;
          if(this.lrOrganizationId && this.lrOrganizations.filter(f => f.key == this.lrOrganizationId).length == 0) {
            this.$router.push('/');
            location.reload();
          }
        });

      axios
        .get('/Dictionary/GetKinshipTypes')
        .then((response) => {
          this.kinshipTypes = response.data;
        });

      axios
        .get('/Dictionary/GetTcOrganizationCodes')
        .then((response) => {
          this.tcOrganizations = response.data;
        });
    },
    search: function() {
      this.$emit('search', {
        status: this.form.status,
        operatorId: this.form.operatorId,
        kinship: this.form.kinship,
        externalId: this.form.externalId,
        lrOrganizationId: this.form.lrOrganizationId,
        tcOrganizationId: this.form.tcOrganizationId,
      });
    },
    resetFilter(e) {
      this.reset(e, () => {
        if (this.$auth.user().isLr) {
          this.form.lrOrganizationId = this.$auth.user().currentOrganization.id;
        }
      });
    },
    ageHandler(e) {
      this.form.ageFrom = e.ageFrom;
      this.form.ageTo = e.ageTo;
    },
  },
  computed: {
    sortedHlas: function() {
      if (!this.patient || !this.patient.hlas) return [];

      let sorted = this.patient.hlas.slice();
      sorted.forEach(function(val) {
        if (val.hlaTypeName == 'DQB1*') {
          val.sortValue = val.hlaTypeValue + 1;
        } else if (val.hlaTypeName == 'DRB1*') {
          val.sortValue = val.hlaTypeValue - 1;
        } else {
          val.sortValue = val.hlaTypeValue;
        }
      });
      sorted.sort(function(a, b) {
        return a.sortValue - b.sortValue;
      });
      return sorted;
    },

    common: function() {
      const arr = [this.fullName, this.birthday, this.diagnosis];

      if (this.$auth.user().isRdkm) {
        arr.push(this.tc);
      }

      let result = '';
      arr.forEach(function(element) {
        if (element) {
          result += '. ' + element;
        }
      });
      if (result) {
        result = result.substring(2);
      }
      return result;
    },

    fullName: function() {
      if (!this.patient) return '';

      const arr = [
        this.patient.lastName,
        this.patient.firstName,
        this.patient.middleName,
      ];
      let result = '';
      arr.forEach(function(element) {
        if (element) {
          if (result) {
            result += ' ';
          }
          result += element;
        }
      });
      return result;
    },

    birthday: function() {
      if (!this.patient) return '';

      if (!this.patient.birthday) {
        return '';
      }
      return (
        '<b>' + this.$t('Дата рождения') + ': </b>' +
        moment(new Date(this.patient.birthday)).format('DD.MM.YYYY')
      );
    },

    diagnosis: function() {
      return '<b>' + this.$t('Диагноз') + ': </b>' + this.diagnosisName;
    },

    diagnosisName: function() {
      if (!this.patient || !this.patient.diagnosis) {
        return '';
      }

      return this.patient.diagnosis;
    },

    tc: function() {
      if (!this.patient) return '';

      return '<b>' + this.$t('ТЦ') + ': </b>' + this.patient.organizationCode;
    },
  },
};
</script>
